import React, { useEffect, useState } from "react";
import { GetAllSubadmin } from "../../CommonAPI/Admin";
import FullDataTable from "../../../ExtraComponent/CommanDataTable";
import { useNavigate } from "react-router-dom";
import { SquarePen } from "lucide-react";
import NoDataFound from "../../../ExtraComponent/NoDataFound";
import Content from "../../../ExtraComponent/Content";

const AllSubadmin = () => {
  const navigate = useNavigate();
  const [clientService, setClientService] = useState({
    loading: true,
    data: [],
  });
  const [searchInput, setSearchInput] = useState("");

  useEffect(() => {
    fetchAllSubadmin();
  }, [searchInput]);

  const fetchAllSubadmin = async () => {
    try {
      const response = await GetAllSubadmin();
      if (response.Status) {
        const filteredData = response.Data.filter((item) => {
          const searchInputMatch =
            searchInput === "" ||
            item.Username.toLowerCase().includes(searchInput.toLowerCase()) ||
            item.Name.toLowerCase().includes(searchInput.toLowerCase()) ||
            item.EmailId.toLowerCase().includes(searchInput.toLowerCase()) ||
            item.Mobile_No.toLowerCase().includes(searchInput.toLowerCase());
          return searchInputMatch;
        });

        setClientService({
          loading: false,
          data: searchInput ? filteredData : response.Data,
        });
      } else {
        setClientService({ loading: false, data: [] });
      }
    } catch (error) {
      console.log("Error in fetching Subadmin", error);
    }
  };

  const EditSubadmindetail = (value, tableMeta) => {
    const rowIndex = tableMeta.rowIndex;
    const rowData = tableMeta.rowData;

    navigate(`/admin/editSubadmin`, {
      state: { rowIndex, rowData },
    });
  };

  const columns = [
    {
      name: "S.No",
      label: "S.No",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => tableMeta.rowIndex + 1,
      },
    },

    {
      name: "Name",
      label: "Name",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "Username",
      label: "Username",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "Mobile_No",
      label: "Mobile Number",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "EmailId",
      label: "Email ID",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },

    {
      name: "CreateDate",
      label: "Create Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => value || "-",
      },
    },
    {
      name: "Permission",
      label: "Permission ",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          if (Array.isArray(value)) {
            return (
              <>
               <select className="form-select form-select-sm" aria-label=".form-select-sm example" style={{minWidth:"120px"}}>
                {value.map((perm, index) => (
                  <option key={index} value={perm}>{perm}</option>
                 
                ))}
              </select>
              </>
            );
          }
        },
      },
    },
      {
        name: 'Active_Live_Account',
        label: 'Active Live Account',
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '0',
        },
    },
        {
        name: 'Active_Demo_Account',
        label: 'Active Demo Account',
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '0',
        },
    },
        {
        name: 'Total Revenue',
        label: 'Total Revenue',
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '0',
        },
    },
            {
        name: 'Total_Live_Account',
        label: 'Total Live Account',
        options: {
            filter: true,
            sort: true,
            customBodyRender: (value) => value || '0',
        },
    },
    {
      name: "Edit",
      label: "Edit",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta) => {
          return (
            <SquarePen
              onClick={() => EditSubadmindetail(value, tableMeta)}
              style={{ cursor: "pointer" }}
            />
          );
        },
      },
    },
  ];

  return (
    <>
      <Content
        Page_title={"Subadmins"}
        button_status={true}
        backbutton_status={true}
        route={"/admin/addSubadmin"}
        button_title={"Add SubAdmin"}
      >
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item active " aria-current="page">
              Subadmins
            </li>
          </ol>
        </nav>
        <div className="">
          <div className="d-flex justify-content-between card-bg-color mb-3 align-items-center">
            <div className=" col-lg-3">
              <input
                type="text"
                className="form-control rounded p-1 px-2"
                placeholder="Search..."
                onChange={(e) => setSearchInput(e.target.value)}
                value={searchInput}
              />
            </div>

            <button
              className="addbtn btn"
              color="addbtn btn"
              onClick={() => navigate("/admin/addSubadmin")}
            >
              <i className="fa fa-plus"></i> Add SubAdmin
            </button>
          </div>
        </div>

        {clientService.data && clientService.data.length > 0 ? (
          <FullDataTable
            columns={columns}
            data={clientService.data}
            checkBox={false}
          />
        ) : (
          <NoDataFound />
        )}
      </Content>
    </>
  );
};

export default AllSubadmin;
